import Model from './Model'

export default class Entry extends Model {
  resource () { return 'entries' }
}
